import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

type Props = {
  label: string;
};

/**
 * Held while a legacy link resolves where it now points. Inside the real page
 * chrome rather than PageSkeleton, which stands in before the shell exists and
 * would swap the sidebar for a differently-sized one mid-navigation.
 */
const RedirectingPlaceholder: FC<Props> = (props) => {
  const { label } = props;

  return (
    <AuthenticatedPageWrapper>
      <div className="p-4" role="status" aria-label={label}>
        <SkeletonLoader className="h-8 w-64 rounded" />
      </div>
    </AuthenticatedPageWrapper>
  );
};

export default RedirectingPlaceholder;
